/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { CKEditorModule } from 'ng2-ckeditor';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { AuthModule } from './@auth/auth.module';
import { InitUserService } from './@theme/services/init-user.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; 
import { AngularDeviceInformationService } from 'angular-device-information';
import { Keepalive } from '@ng-idle/keepalive';
import { IdleExpiry, LocalStorage, LocalStorageExpiry, NgIdleModule } from '@ng-idle/core';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { AgmCoreModule } from '@agm/core';
import { CallService } from './@core/backend/common/services/videoCall.service'; 
import { VideoCallService } from './@theme/components/common/service/VideoCall.service';
import { FaviconService } from './favicon-service';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { AudioCallService } from './@theme/components/common/service/audio-call.service';


export function init_app(injector: Injector) {
  return () =>
    new Promise<any>((resolve: Function) => {
      const initUserService = injector.get(InitUserService);
      initUserService.initCurrentUser().subscribe(() => { },
        () => resolve(), () => resolve()); // a place for logging error
    });
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,NgIdleModule.forRoot(),
    CKEditorModule,
    ThemeModule.forRoot(),
    AuthModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: environment.chatGoogleMapKey,
    }),
    AgmCoreModule.forRoot({
      // please get your own API key here:
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en
      apiKey: environment.agmApiKey
    }),
    CoreModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
  ],
  bootstrap: [AppComponent],
  providers: [ VideoCallService,AudioCallService,
    CallService,FaviconService,Keepalive,
    // One idle clock for all open tabs (kept in localStorage) instead of one per tab: otherwise a tab
    // that looks idle signs the user out of the tab they are actually working in.
    LocalStorage,
    { provide: IdleExpiry, useClass: LocalStorageExpiry },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [Injector],
      multi: true,
    },[AngularDeviceInformationService],
  ],
})
export class AppModule {
}
